import { CatHeading } from '@blocks-react/components/Heading';
import { SystemAndComponentHeadingProps } from '../types';

export const SystemAndComponentHeading = ({
  children,
  classname,
  variant
}: SystemAndComponentHeadingProps) => {
  return (
    <div className={classname}>
      <CatHeading variant={variant} className="px-blg-3 pb-blg-2 d-block">
        {children}
      </CatHeading>
    </div>
  );
};
